import { render, staticRenderFns } from "./Caja.vue?vue&type=template&id=34629627&"
import script from "./Caja.vue?vue&type=script&lang=js&"
export * from "./Caja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports